export default {
  DESKTOP: 1280,
  SMALLDESKTOP: 1140,
  TABLET: 768,
  PHONE: 520,
};
